import { useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getSpaceDefaultNotificationSettingsKey } from '../../utils/keys';
export const useSpaceDefaultNotificationSettings = (options) => {
    const { variables, useQueryOptions } = options;
    const { client } = useTribeClient();
    const spaceDefaultNotificationSettingsKey = getSpaceDefaultNotificationSettingsKey({ variables });
    return useQuery(spaceDefaultNotificationSettingsKey, () => client.notifications.spaceDefaultNotificationSettings(variables), useQueryOptions);
};
//# sourceMappingURL=useSpaceDefaultNotificationSettings.js.map